module.exports = __webpack_public_path__ + "img/헤럴드경제.66ef6135.png";